import * as React from 'react';
import Radio from '@mui/material/Radio';
import {FormControlLabel,FormLabel,TextField} from '@mui/material'
import { styled } from '@mui/material/styles';
import './App.css'

export const StyledRadio = styled(Radio)(({ theme }) => ({
    '&.Mui-checked': {
        color:'rgba(188,71,77 ,1)',
    },
    '&.Mui-hover': {
        color:'rgba(188,71,77 ,1)',
    }
  }),
);

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    '& .MuiFormControlLabel-label': {
      fontFamily: 'comicbold',
    },
  }));
  

export const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
    fontFamily:'comicbold',
    '&.Mui-focused': {
      color: 'rgba(188,71,77 ,1)',
      fontFamily: 'comicbold',
    },
  }),
);

export const StyledTextField = styled(TextField)(({ theme}) => ({
    '& .MuiInputBase-input': {
      fontSize: theme.typography.pxToRem(17),
    },
    '& .MuiInputBase-root': {
    alignItems: 'start',
    },
    '& .MuiInputBase-inputMultiline': {
      height: '100% !important',
      overflowY: 'auto',
    },
    '& .MuiInputBase-root textarea': {
      resize: 'none',              // 重要：禁用 textarea 的 resize
      overflow: 'auto',            // 避免内容变化触发组件重绘
    },
    '& .MuiInputLabel-root': {
      color: 'rgb(141, 141, 141)',
      fontFamily: 'comicregular',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'rgba(188,71,77 ,1)',
      fontFamily: 'comicbold',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'rgb(141, 141, 141)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(188,71,77 ,1)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'rgba(188,71,77 ,1)',
      },
    },
  }));
